import { SuccessPlaceholder, WizardFooter, WizardTitle } from "@components"
import  PresendSummary from "./PresendSummary"
import { PaperAirplaneIcon } from "@heroicons/react/24/outline"
import { PropTypes } from "prop-types"

const Step4 = ({ 
  counts,
  notificationType, 
  handlePrevious, 
  handleFinish, 
  isComplete,
  isSubmitting,
}) => (
  <div>
    {!isComplete && (
      <WizardTitle
        title="Step 4 of 4 - Confirm & Send"
        description="Review the summary and click 'Send Notifications' to send the notifications."
        icon={<PaperAirplaneIcon />}
      />
    )}

    {!isComplete && <PresendSummary counts={counts} notificationType={notificationType} />}

    {isComplete && (
      <SuccessPlaceholder 
        title="Notification Created" 
        message={`Your notification has been created. 
          ${notificationType.is_email
            ? "Emails are currently being queued and sent out to all selected recipients. View the relevant notification in the table for progress." 
            : "Notifications have been sent to all selected recipients. This will be displayed in the parents portal when they next log in."
          }`}  
      />         
    )}

    <WizardFooter 
      currentStep={4} 
      totalSteps={4} 
      isPreviousButtonDisabled={isSubmitting || isComplete}
      previousCaption="Filter Guardians" 
      nextCaption={isComplete ? 'Close' : 'Send Notifications'}
      handlePrevious={() => handlePrevious()} 
      handleNext={() => handleFinish()} 
      isSubmitting={isSubmitting}
    />
  </div>
)

Step4.propTypes = {
  counts: PropTypes.shape({
    deselected: PropTypes.number.isRequired,
    selected: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  
  handlePrevious: PropTypes.func.isRequired,
  handleFinish: PropTypes.func.isRequired,
  isComplete: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  notificationType: PropTypes.object.isRequired,
}

export default Step4